import axios from "axios";
import authHeader from "@/services/auth-header";
import { DICTIONARIES_ENDPOINT } from "@/constants/endpoints";
import PortalDictionaryDTO from "@/dto/common/PortalDictionaryDTO";

class CommonService {
  findByGroupName(groupName: string) {
    return axios.get<Array<PortalDictionaryDTO>>(`${DICTIONARIES_ENDPOINT}/${groupName}`,{headers: authHeader()})
  }
}

export default new CommonService();
